export default {
  exitNavbar: 'خروج',
  homeNavbar: 'خانه',
  profileNavbar: 'نمایه',
  tasksNavbar: 'وظایف',
  login: 'ورود',
  user: 'بدون اسم',
  getTitle(title) {
    switch (title.view) {
      case 'task':
        return 'مدیریت وظیفه‌ها';
      case 'company':
        if (title.name) {
          return `مدیریت ${title.name}`;
        }
        return '‌مدیریت شرکت‌ها';
      case 'project':
        if (title.name) {
          return `مدیریت پروژه ${title.name}`;
        }
        return 'مدیریت پروژه‌ها';
      case 'template':
        if (title.name) {
          return `مدیریت قالب ${title.name}`;
        }
        return 'مدیریت قالب‌ها';
      case 'inbox':
        return 'صندوق پیام';
      case 'profile':
        return 'نمایه';
      case 'provider':
        return title.name;
      case '/content':
        return 'مدیریت محتوا';
      case '/general':
        return 'اطلاعات کلی';
      case '/pictures':
        return 'تصاویر پروفایل';
      case '/social':
        return 'شبکه‌های اجتماعی و ارتباطات';
      case '/tags':
        return 'برچسب‌ها';
      case '/templates':
        return 'قالب‌ها';
      default:
        return 'مدیریت';
    }
  },
};
